module.exports = __webpack_public_path__ + "img/kjsy_gallery3.d02bcffc.jpg";